import moment from 'moment';

const formatDateOnly = (date) => {
  return moment(date).format('YYYY/MM/DD');
}

const formatSaleDate = (date) => {
  return moment(date).format('YYYY年MM月發售');
}

const ceil = (price, decision = 0) => {
  const n = Math.pow(10, decision);
  return Math.ceil(price * n) / n;
}

const floor = (price, decision = 0) => {
  const n = Math.pow(10, decision);
  return Math.floor(price * n) / n;
}

const formatPrice = (num) => {
  if (num == null) return '0';
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const timeLeft = (date) => {
  return moment(date).diff(moment(), 'days') + '天';
}

const formatNumberLength = (num, length) => {
  if (num.toString().length >= length) return num;
  return (Array(length).join('0') + num).slice(-length);
}

const formatPriceCalculateType = (type) => {
  switch (type) {
    case 'exchange_rate_discount':
      return '匯率折扣';
    case 'sale_price_discount':
      return '售價折扣';
    case 'sell_price':
      return '售價';
    default:
      return '(錯誤類型)';
  }
}

const formatMonetaryTypeName = (type) => {
  switch (type) {
    case 1:
      return '台幣';
    case 2:
      return '美金';
    case 3:
      return '日幣';
    case 4:
      return '人民幣';
    default:
      return '$';
  }
}

const formatMonetaryTypePrefix = (type) => {
  switch (type) {
    case 1:
      return '$';
    case 2:
      return '$';
    case 3:
      return '¥';
    case 4:
      return '¥';
    default:
      return '$';
  }
}

const formatMonetaryTypeSuffix = (type) => {
  switch (type) {
    case 1:
      return '元';
    case 2:
      return '美金';
    case 3:
      return '円';
    case 4:
      return '人民幣';
    default:
      return '元';
  }
}

export {
  ceil,
  floor,
  timeLeft,
  formatDateOnly,
  formatSaleDate,
  formatPrice,
  formatNumberLength,
  formatPriceCalculateType,
  formatMonetaryTypeName,
  formatMonetaryTypePrefix,
  formatMonetaryTypeSuffix,
}
